// extracted by mini-css-extract-plugin
export default {"protocol":"ProtocolWidget_protocol__vDdRo","tips":"ProtocolWidget_tips__OGevj"};